@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(162_072_189)
internal val Res.drawable.stella_perfetta: DrawableResource by lazy {
      DrawableResource("drawable:stella_perfetta", setOf(
        ResourceItem(setOf(), "${MD}drawable/stella_perfetta.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_221_938_254)
internal val Res.drawable.stoppino_lampada: DrawableResource by lazy {
      DrawableResource("drawable:stoppino_lampada", setOf(
        ResourceItem(setOf(), "${MD}drawable/stoppino_lampada.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_565_546_242)
internal val Res.drawable.sw: DrawableResource by lazy {
      DrawableResource("drawable:sw", setOf(
        ResourceItem(setOf(), "${MD}drawable/sw.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-126_877_901)
internal val Res.drawable.swipe_down: DrawableResource by lazy {
      DrawableResource("drawable:swipe_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/swipe_down.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_038_843_220)
internal val Res.drawable.swipe_up: DrawableResource by lazy {
      DrawableResource("drawable:swipe_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/swipe_up.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_269_426_749)
internal val Res.drawable.tale_12_24: DrawableResource by lazy {
      DrawableResource("drawable:tale_12_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/tale_12_24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_396_084_729)
internal val Res.drawable.tale_1_12: DrawableResource by lazy {
      DrawableResource("drawable:tale_1_12", setOf(
        ResourceItem(setOf(), "${MD}drawable/tale_1_12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_553_578_693)
internal val Res.drawable.tale_24_37: DrawableResource by lazy {
      DrawableResource("drawable:tale_24_37", setOf(
        ResourceItem(setOf(), "${MD}drawable/tale_24_37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-660_110_154)
internal val Res.drawable.tale_37_51: DrawableResource by lazy {
      DrawableResource("drawable:tale_37_51", setOf(
        ResourceItem(setOf(), "${MD}drawable/tale_37_51.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-93_897_244)
internal val Res.drawable.tale_first_sentence: DrawableResource by lazy {
      DrawableResource("drawable:tale_first_sentence", setOf(
        ResourceItem(setOf(), "${MD}drawable/tale_first_sentence.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-246_460_572)
internal val Res.drawable.tigrato: DrawableResource by lazy {
      DrawableResource("drawable:tigrato", setOf(
        ResourceItem(setOf(), "${MD}drawable/tigrato.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-954_078_577)
internal val Res.drawable.time: DrawableResource by lazy {
      DrawableResource("drawable:time", setOf(
        ResourceItem(setOf(), "${MD}drawable/time.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-615_183_430)
internal val Res.drawable.to_be_high: DrawableResource by lazy {
      DrawableResource("drawable:to_be_high", setOf(
        ResourceItem(setOf(), "${MD}drawable/to_be_high.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-552_831_851)
internal val Res.drawable.top: DrawableResource by lazy {
      DrawableResource("drawable:top", setOf(
        ResourceItem(setOf(), "${MD}drawable/top.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_102_497_319)
internal val Res.drawable.triangle: DrawableResource by lazy {
      DrawableResource("drawable:triangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/triangle.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(188_714_040)
internal val Res.drawable.triangle90: DrawableResource by lazy {
      DrawableResource("drawable:triangle90", setOf(
        ResourceItem(setOf(), "${MD}drawable/triangle90.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_782_402_084)
internal val Res.drawable.tutankhamon: DrawableResource by lazy {
      DrawableResource("drawable:tutankhamon", setOf(
        ResourceItem(setOf(), "${MD}drawable/tutankhamon.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_729_263_758)
internal val Res.drawable.tutankhamon2: DrawableResource by lazy {
      DrawableResource("drawable:tutankhamon2", setOf(
        ResourceItem(setOf(), "${MD}drawable/tutankhamon2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_121_935_053)
internal val Res.drawable.tuxedo: DrawableResource by lazy {
      DrawableResource("drawable:tuxedo", setOf(
        ResourceItem(setOf(), "${MD}drawable/tuxedo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(335_490_433)
internal val Res.drawable.tuxedo_tigrato: DrawableResource by lazy {
      DrawableResource("drawable:tuxedo_tigrato", setOf(
        ResourceItem(setOf(), "${MD}drawable/tuxedo-tigrato.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_384_879_471)
internal val Res.drawable.uni_bi_tri: DrawableResource by lazy {
      DrawableResource("drawable:uni_bi_tri", setOf(
        ResourceItem(setOf(), "${MD}drawable/uni_bi_tri.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_169_242_625)
internal val Res.drawable.uomo_bocca: DrawableResource by lazy {
      DrawableResource("drawable:uomo_bocca", setOf(
        ResourceItem(setOf(), "${MD}drawable/uomo_bocca.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(769_523_354)
internal val Res.drawable.uomo_mani_alto: DrawableResource by lazy {
      DrawableResource("drawable:uomo_mani_alto", setOf(
        ResourceItem(setOf(), "${MD}drawable/uomo_mani_alto.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(562_672_347)
internal val Res.drawable.usekh: DrawableResource by lazy {
      DrawableResource("drawable:usekh", setOf(
        ResourceItem(setOf(), "${MD}drawable/usekh.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(275_015_527)
internal val Res.drawable.ventre_vacca: DrawableResource by lazy {
      DrawableResource("drawable:ventre_vacca", setOf(
        ResourceItem(setOf(), "${MD}drawable/ventre_vacca.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(152_013_861)
internal val Res.drawable.viking: DrawableResource by lazy {
      DrawableResource("drawable:viking", setOf(
        ResourceItem(setOf(), "${MD}drawable/viking.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_424_349_721)
internal val Res.drawable.vipera_cornuta: DrawableResource by lazy {
      DrawableResource("drawable:vipera_cornuta", setOf(
        ResourceItem(setOf(), "${MD}drawable/vipera_cornuta.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-936_980_533)
internal val Res.drawable.zeta_base: DrawableResource by lazy {
      DrawableResource("drawable:zeta_base", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_base.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_473_473_444)
internal val Res.drawable.zeta_dress: DrawableResource by lazy {
      DrawableResource("drawable:zeta_dress", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_dress.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-166_698_502)
internal val Res.drawable.zeta_dress_0: DrawableResource by lazy {
      DrawableResource("drawable:zeta_dress_0", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_dress_0.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_053_346_608)
internal val Res.drawable.zeta_dress_1: DrawableResource by lazy {
      DrawableResource("drawable:zeta_dress_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_dress_1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_001_561_312)
internal val Res.drawable.zeta_dress_2: DrawableResource by lazy {
      DrawableResource("drawable:zeta_dress_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_dress_2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(517_657_581)
internal val Res.drawable.zeta_dress_3: DrawableResource by lazy {
      DrawableResource("drawable:zeta_dress_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_dress_3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_082_300_394)
internal val Res.drawable.zeta_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:zeta_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_281_200_040)
internal val Res.drawable.zeta_eyebrows_doubt: DrawableResource by lazy {
      DrawableResource("drawable:zeta_eyebrows_doubt", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_eyebrows_doubt.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(769_829_100)
internal val Res.drawable.zeta_eyebrows_idle: DrawableResource by lazy {
      DrawableResource("drawable:zeta_eyebrows_idle", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_eyebrows_idle.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-551_485_251)
internal val Res.drawable.zeta_glasses: DrawableResource by lazy {
      DrawableResource("drawable:zeta_glasses", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_glasses.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_781_352_618)
internal val Res.drawable.zeta_glasses_cover: DrawableResource by lazy {
      DrawableResource("drawable:zeta_glasses_cover", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_glasses_cover.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_284_598_197)
internal val Res.drawable.zeta_glasses_cyclop: DrawableResource by lazy {
      DrawableResource("drawable:zeta_glasses_cyclop", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_glasses_cyclop.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(646_841_579)
internal val Res.drawable.zeta_glasses_cyclop_accent: DrawableResource by lazy {
      DrawableResource("drawable:zeta_glasses_cyclop_accent", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_glasses_cyclop_accent.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_148_315_108)
internal val Res.drawable.zeta_glasses_gold: DrawableResource by lazy {
      DrawableResource("drawable:zeta_glasses_gold", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_glasses_gold.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-756_686_649)
internal val Res.drawable.zeta_glasses_pixel: DrawableResource by lazy {
      DrawableResource("drawable:zeta_glasses_pixel", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_glasses_pixel.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(596_874_888)
internal val Res.drawable.zeta_hair: DrawableResource by lazy {
      DrawableResource("drawable:zeta_hair", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_hair.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_582_173_719)
internal val Res.drawable.zeta_mouth_doubt: DrawableResource by lazy {
      DrawableResource("drawable:zeta_mouth_doubt", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_mouth_doubt.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_536_733_726)
internal val Res.drawable.zeta_mouth_idle: DrawableResource by lazy {
      DrawableResource("drawable:zeta_mouth_idle", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_mouth_idle.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(938_340_189)
internal val Res.drawable.zeta_mouth_surprise_0: DrawableResource by lazy {
      DrawableResource("drawable:zeta_mouth_surprise_0", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_mouth_surprise_0.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-670_652_356)
internal val Res.drawable.zeta_nose: DrawableResource by lazy {
      DrawableResource("drawable:zeta_nose", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_nose.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(795_359_987)
internal val Res.drawable.zeta_skin: DrawableResource by lazy {
      DrawableResource("drawable:zeta_skin", setOf(
        ResourceItem(setOf(), "${MD}drawable/zeta_skin.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable13Resources(map: MutableMap<String, DrawableResource>) {
  map.put("stella_perfetta", Res.drawable.stella_perfetta)
  map.put("stoppino_lampada", Res.drawable.stoppino_lampada)
  map.put("sw", Res.drawable.sw)
  map.put("swipe_down", Res.drawable.swipe_down)
  map.put("swipe_up", Res.drawable.swipe_up)
  map.put("tale_12_24", Res.drawable.tale_12_24)
  map.put("tale_1_12", Res.drawable.tale_1_12)
  map.put("tale_24_37", Res.drawable.tale_24_37)
  map.put("tale_37_51", Res.drawable.tale_37_51)
  map.put("tale_first_sentence", Res.drawable.tale_first_sentence)
  map.put("tigrato", Res.drawable.tigrato)
  map.put("time", Res.drawable.time)
  map.put("to_be_high", Res.drawable.to_be_high)
  map.put("top", Res.drawable.top)
  map.put("triangle", Res.drawable.triangle)
  map.put("triangle90", Res.drawable.triangle90)
  map.put("tutankhamon", Res.drawable.tutankhamon)
  map.put("tutankhamon2", Res.drawable.tutankhamon2)
  map.put("tuxedo", Res.drawable.tuxedo)
  map.put("tuxedo_tigrato", Res.drawable.tuxedo_tigrato)
  map.put("uni_bi_tri", Res.drawable.uni_bi_tri)
  map.put("uomo_bocca", Res.drawable.uomo_bocca)
  map.put("uomo_mani_alto", Res.drawable.uomo_mani_alto)
  map.put("usekh", Res.drawable.usekh)
  map.put("ventre_vacca", Res.drawable.ventre_vacca)
  map.put("viking", Res.drawable.viking)
  map.put("vipera_cornuta", Res.drawable.vipera_cornuta)
  map.put("zeta_base", Res.drawable.zeta_base)
  map.put("zeta_dress", Res.drawable.zeta_dress)
  map.put("zeta_dress_0", Res.drawable.zeta_dress_0)
  map.put("zeta_dress_1", Res.drawable.zeta_dress_1)
  map.put("zeta_dress_2", Res.drawable.zeta_dress_2)
  map.put("zeta_dress_3", Res.drawable.zeta_dress_3)
  map.put("zeta_eyebrows", Res.drawable.zeta_eyebrows)
  map.put("zeta_eyebrows_doubt", Res.drawable.zeta_eyebrows_doubt)
  map.put("zeta_eyebrows_idle", Res.drawable.zeta_eyebrows_idle)
  map.put("zeta_glasses", Res.drawable.zeta_glasses)
  map.put("zeta_glasses_cover", Res.drawable.zeta_glasses_cover)
  map.put("zeta_glasses_cyclop", Res.drawable.zeta_glasses_cyclop)
  map.put("zeta_glasses_cyclop_accent", Res.drawable.zeta_glasses_cyclop_accent)
  map.put("zeta_glasses_gold", Res.drawable.zeta_glasses_gold)
  map.put("zeta_glasses_pixel", Res.drawable.zeta_glasses_pixel)
  map.put("zeta_hair", Res.drawable.zeta_hair)
  map.put("zeta_mouth_doubt", Res.drawable.zeta_mouth_doubt)
  map.put("zeta_mouth_idle", Res.drawable.zeta_mouth_idle)
  map.put("zeta_mouth_surprise_0", Res.drawable.zeta_mouth_surprise_0)
  map.put("zeta_nose", Res.drawable.zeta_nose)
  map.put("zeta_skin", Res.drawable.zeta_skin)
}
